import React, { useEffect } from 'react';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { breadCrumbSelector } from '../../selectors/routing/routingSelector';
import './Breadcrumbs.scss';

type TBreadcrumbs = {
  passedInCurrent?: {
    name: string;
    link: {
      url: string;
    };
  };
};

type TLocationState = {
  from?: string;
};

const Breadcrumbs = ({ passedInCurrent }: TBreadcrumbs) => {
  const location = useLocation<TLocationState>();
  const match = useRouteMatch();

  const breadcrumbs = useSelector(state =>
    breadCrumbSelector(state, { location, match })
  );

  const { current, parents } = breadcrumbs || { current: null, parents: [] };

  useEffect(() => {
    if (location.state?.from === 'category-nav') {
      const pageTitleLink = document.getElementById('page-title-link');
      pageTitleLink?.focus();
    }
  }, [location.state]);

  return (
    <ul
      className="c-breadcrumbs"
      itemScope
      itemType="http://schema.org/BreadcrumbList"
    >
      {parents.map(
        (page, index) =>
          page && (
            <li
              key={index}
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
            >
              <Link to={page.link.url} itemProp="item">
                <span itemProp="name">{page.name}</span>
              </Link>
              <meta itemProp="position" content={index} />
            </li>
          )
      )}

      {current && (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="http://schema.org/ListItem"
        >
          <Link to={current.link.url} itemProp="item" id="page-title-link">
            <h1 itemProp="name">{current.name}</h1>
          </Link>
          <meta itemProp="position" content="2" />
        </li>
      )}

      {passedInCurrent && (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="http://schema.org/ListItem"
        >
          <Link to={passedInCurrent.link.url} itemProp="item">
            <h1 itemProp="name">{passedInCurrent.name}</h1>
          </Link>
          <meta itemProp="position" content="3" />
        </li>
      )}
    </ul>
  );
};

export default Breadcrumbs;
